var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutoResponders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19070_1728",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -0.0673828,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19070_1728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 13.4711L15.3077 9.93262L10 6.39412V13.4711ZM2.5 20.9711V4.24037C2.5 3.7352 2.675 3.30762 3.025 2.95762C3.375 2.60762 3.80258 2.43262 4.30775 2.43262H19.6923C20.1974 2.43262 20.625 2.60762 20.975 2.95762C21.325 3.30762 21.5 3.7352 21.5 4.24037V15.6249C21.5 16.13 21.325 16.5576 20.975 16.9076C20.625 17.2576 20.1974 17.4326 19.6923 17.4326H6.0385L2.5 20.9711ZM5.4 15.9326H19.6923C19.7693 15.9326 19.8398 15.9005 19.9038 15.8364C19.9679 15.7724 20 15.7019 20 15.6249V4.24037C20 4.16337 19.9679 4.09287 19.9038 4.02887C19.8398 3.9647 19.7693 3.93262 19.6923 3.93262H4.30775C4.23075 3.93262 4.16025 3.9647 4.09625 4.02887C4.03208 4.09287 4 4.16337 4 4.24037V17.3174L5.4 15.9326Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoResponders);
export default __webpack_public_path__ + "static/media/auto-responders.69eeedcefb5e835dd10ac16cc5f1ce71.svg";
export { ForwardRef as ReactComponent };